export const isCanvasSupported = () => {
  const elem = document.createElement("canvas");
  try {
    if (!elem.getContext || !elem.getContext("2d")) {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
};

let isCanvasFilterSupported = false;
if (isCanvasSupported()) {
  const ctx = document.createElement("canvas").getContext("2d");
  if (ctx) {
    isCanvasFilterSupported = ctx.filter !== undefined;
  }
}

let _shadowLine;
let _neonLine;
if (isCanvasFilterSupported) {
  _shadowLine = (
    ctx: CanvasRenderingContext2D,
    x1: number,
    y1: number,
    x2: number,
    y2: number,
    blurAmountPx = 4,
    shadowX = 2,
    shadowY = 2
  ) => {
    ctx.filter = `drop-shadow(${shadowX}px ${shadowY}px ${blurAmountPx}px)`;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
    ctx.filter = "none";
  };

  _neonLine = (
    ctx: CanvasRenderingContext2D,
    x1: number,
    y1: number,
    x2: number,
    y2: number,
    blurAmountPx: number,
    blurAlpha = 1.0
  ) => {
    ctx.globalAlpha = blurAlpha;
    ctx.filter = `blur(${blurAmountPx}px)`;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
    ctx.globalAlpha = 1;
    ctx.filter = "none";
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
  };
} else {
  _shadowLine = (
    ctx: CanvasRenderingContext2D,
    x1: number,
    y1: number,
    x2: number,
    y2: number,
    blurAmountPx = 4,
    shadowX = 2,
    shadowY = 2
  ) => {
    const prevStrokeStyle = ctx.strokeStyle;

    for (let i = 0; i < blurAmountPx + 1; i += 2) {
      ctx.strokeStyle = "rgba(0, 0, 0, 0.2)";
      ctx.beginPath();
      ctx.moveTo(x1 + shadowX + i, y1 + shadowY + i);
      ctx.lineTo(x2 + shadowX + i, y2 + shadowY + i);
      ctx.stroke();
    }

    ctx.strokeStyle = prevStrokeStyle;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
  };

  _neonLine = (
    ctx: CanvasRenderingContext2D,
    x1: number,
    y1: number,
    x2: number,
    y2: number,
    blurAmountPx: number,
    blurAlpha = 1.0
  ) => {
    const prevLineWidth = ctx.lineWidth;
    for (let i = 0; i < blurAmountPx + 2; i += 2) {
      ctx.lineWidth = prevLineWidth + i * 3;
      ctx.globalAlpha = 0.05 * blurAlpha;
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
    }
    ctx.globalAlpha = 1;

    ctx.lineWidth = prevLineWidth;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
  };
}

export const shadowLine = _shadowLine;
export const neonLine = _neonLine;

const average = (array) => array.reduce((a, b) => a + b) / array.length;

export const smoothPath = (path, smoothness) => {
  const smoothedPath: any[] = [];
  for (let i = 0; i < path.length; i++) {
    const x = path[i][0];
    const x0 = Math.max(0, i - smoothness);
    const x1 = Math.min(path.length - 1, i + smoothness);
    const y_smoothed = average(path.slice(x0, x1 + 1).map((p) => p[1]));
    smoothedPath.push({ x: x, y: y_smoothed });
  }
  return smoothedPath;
};

export const opacity = (color: string, opacity: number) => {
  if (color.startsWith("#")) {
    if (color.length < 7) {
      return color;
    }
    const red = parseInt(color.substring(1, 3), 16);
    const green = parseInt(color.substring(3, 5), 16);
    const blue = parseInt(color.substring(5, 7), 16);
    return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
  }
  const rgb = color.match(/\d+/g);
  if (!rgb) return color;
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity})`;
};

export const roundRect = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number
) => {
  // context.roundRect is not supported in all browsers, so we use this function instead
  if (width < 2 * radius) radius = width / 2;
  if (height < 2 * radius) radius = height / 2;
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + width, y, x + width, y + height, radius);
  ctx.arcTo(x + width, y + height, x, y + height, radius);
  ctx.arcTo(x, y + height, x, y, radius);
  ctx.arcTo(x, y, x + width, y, radius);
  ctx.closePath();
};
